import axios from 'axios';

const API_BASE_URL = `${process.env.REACT_APP_API_BASE_URL}/achat/avoir`;

export const createAvoirAchat = (data) => axios.post(`${API_BASE_URL}/create`, data);
export const saveAvoirAchat = (payload) => axios.put(`${API_BASE_URL}/save`, payload);
export const getAvoirAchat = (id) => axios.get(`${API_BASE_URL}/get/${id}`);
export const listAvoirsAchat = (params) => axios.get(`${API_BASE_URL}/list`, { params });
export const getItemsInAvoirAchat = (id) => axios.get(`${API_BASE_URL}/items/${id}`);
export const validateAvoirAchat = (id) => axios.post(`${API_BASE_URL}/validate/${id}`);
export const unvalidateAvoirAchat = (id) => axios.post(`${API_BASE_URL}/unvalidate/${id}`);

